export default __webpack_public_path__ + "static/media/sb.79b88d1b.svg";